import { Button, Popconfirm } from 'antd';
import type { CompanyAccountView } from '../company-accounts.api';

interface CompanyAccountRowActionsProps {
  account: CompanyAccountView;
  onEdit: (account: CompanyAccountView) => void;
  onRetire: (account: CompanyAccountView) => Promise<void>;
  onRemove: (account: CompanyAccountView) => Promise<void>;
}

/** A used account is evidence for the receipts naming it, so it can only be retired; an unused one can be edited or deleted. A retired one has nothing left to do. */
export function CompanyAccountRowActions({ account, onEdit, onRetire, onRemove }: CompanyAccountRowActionsProps) {
  if (account.status === 'retired') return null;

  if (account.isUsed) {
    return (
      <Popconfirm
        title={`Retire ${account.name}?`}
        description="Receipts already recorded against it keep it. New receipts can no longer choose it."
        okText="Retire"
        onConfirm={() => onRetire(account)}
      >
        <Button size="small">Retire</Button>
      </Popconfirm>
    );
  }

  return (
    <div className="flex justify-end gap-2">
      <Button size="small" onClick={() => onEdit(account)}>
        Edit
      </Button>
      <Popconfirm title={`Delete ${account.name}?`} okText="Delete" okButtonProps={{ danger: true }} onConfirm={() => onRemove(account)}>
        <Button size="small" danger>
          Delete
        </Button>
      </Popconfirm>
    </div>
  );
}
